/**
 * Halte 24-7 - Main Application Entry Point
 * This file is the entry point for Vite bundling
 */

// Import styles
import '@css/app.scss';

// Import Swiper (without default navigation/pagination CSS - we use custom styles)
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, Autoplay };

// Import Axios for HTTP requests
import axios from 'axios';
window.axios = axios;

// Import tail.DateTime from npm package
import DateTime from 'tail.datetime';
import 'tail.datetime/langs/tail.datetime-fr.js';
window.tail = { DateTime };

// Import Pristine form validation
import Pristine from 'pristinejs';
window.Pristine = Pristine;

// Import basicLightbox
import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/dist/basicLightbox.min.css';
window.basicLightbox = basicLightbox;

// Import site modules (they use window.site pattern)
import './site/_scrollTo.js';
import './site/_share-button.js';
import './site/_map.js';
import './site/_ajax-pagination.js';
import './site/_offers-galleries.js';
import './site/_hero-switch.js';
import './site/_spaces-office.js';
import './site/_about-page.js';
import './site/_spaces-galleries.js';
import './site/_offers-space-galleries.js';
import './site/_hall-item-galleries.js';
import './site/_smooth-scrolling.js';
import './site/_menu-mobile.js';
import './site/_youtube-video.js';
import './site/_blog-filter.js';
import './site/_sidepanel.js';
import './site/_book-a-room.js';

// Import main app (must be last)
import './site/app.js';

// Accept HMR
if (import.meta.hot) {
  import.meta.hot.accept();
}
